import React, { useEffect } from 'react';
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import { Course } from "../../components/Course";
import { CourseLessonPage } from '../CourseLessonPage';
import { CourseLessonQuizzPage } from '../CourseLessonQuizzPage';

export function CoursePage({ onMount, onUnmount, onBack }) {
  const { name } = useParams();
  const { path } = useRouteMatch();

  useEffect(() => {
    onMount();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    return () => onUnmount();
  }, [onMount, onUnmount]);

  return (
    <Switch>
      <Route exact path={path}>
        <Course name={name} onBack={onBack} />
      </Route>
      <Route path={`${path}:lessonName/quizz/:quizzName`}>
        <CourseLessonQuizzPage />
      </Route>
      <Route path={`${path}:name/`}>
        <CourseLessonPage />
      </Route>
    </Switch>
  );
}
